import Caldav from '../../services/caldavjs-nextcloud';
import VCF from 'vcf';
import { getBasicAuthCredentials } from '../../services/auth-credentials';
import { getVcfField } from '../../utils/vCard';

const settings = {
  username: '',
  password: '',
  server: window.NEXTCLOUD_URL,
  basePath: '/remote.php/dav',
  timezone: 'Europe/Madrid',
  principalPath: '/principals/users',
  parserLogging: true
};

export const caldav = new Caldav(settings);

// Retrieving addressbook information
export const getAddressbooks = async () => {
  const Addressbooks = await caldav.addressbooks({
    filename: '/addressbooks/users/admin/contacts/'
  });
};

// Get contact string
export const getContactString = async (user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });
  let contactString = 'contacts';
  try {
    await cd.contacts({
      filename: `/addressbooks/users/${mailAccount}/contacts/`
    });
  } catch (error) {
    console.error('No contacts found, trying with contactos', error);
    contactString = 'contactos';
  }
  return contactString;
};

// Get contacts
export const getContactList = async (user, mailAccount, lexonToken) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });
  const contacts = await cd.contacts({
    filename: `/addressbooks/users/${mailAccount}/contacts/`
  });
  return listContactParser(contacts.contacts.filter(c => c.etag !== undefined));
};

// Get filter contacts
export const getContactFilterList = async (user, mailAccount, lexonToken, value, contactString) => {
  const basicAuthToken = await getBasicAuthCredentials(user, mailAccount, lexonToken);
  const cd = new Caldav({
    ...settings,
    username: mailAccount,
    basicAuthToken
  });
  const contacts = await cd.filterContacts({
    filename: `/addressbooks/users/${mailAccount}/${contactString}/`,
    value
  });

  if (!contacts || !contacts.contacts) {
    throw new Error('Invalid response from filterContacts request');
  }
  
  return listContactParser(contacts.contacts?.filter(c => c.etag !== undefined));
};

function listContactParser(list) {
  const contacts = [];
  if (list.length > 0) {
    for (let i = 0; i < list.length; i++) {
      const vcf = new VCF();
      vcf.parse(list[i].address);
      const card = vcf.data || {};
      if (card && getVcfField(card, 'email')) {
        const name = getVcfField(card, 'fn') ? getVcfField(card, 'fn') : '';
        const email = getVcfField(card, 'email') ? getVcfField(card, 'email') : '';
        contacts.push(`${name} (${email})`);
      }
    }
  }
  return contacts;
}

// Create and update contact
export const addContact = async () => {
  const response = await caldav.createContact({
    filename: '/addressbooks/users/admin/contacts/somerandomstring.vcf'
  });
  return response;
};
